import { RootState } from '@app/redux/root-reducer';

export const selectAddCandidateState = (store: RootState) => store.candidateReducer.addCandidate;
export const selectCandidateState = (store: RootState) => store.candidateReducer.candidates;
export const selectUpdateCandidateState = (store: RootState) =>
  store.candidateReducer.updateCandidate;
export const selectUpdateCandidateStatusState = (store: RootState) =>
  store.candidateReducer.updateCandidateStatus;
export const selectCandidatesDetailsByID = (store: RootState) =>
  store.candidateReducer.candidateDetailsById;
